module.exports = __webpack_public_path__ + "index.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=index.html!./docs/src/index.html
 ** module id = 223
 ** module chunks = 0
 **/